import { render } from "./eb-nav.vue?vue&type=template&id=5a3c9682"
import script from "./eb-nav.vue?vue&type=script&lang=ts"
export * from "./eb-nav.vue?vue&type=script&lang=ts"
script.render = render

export default script